"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.toggleShowPartiesFailure = exports.toggleShowPartiesSuccess = exports.toggleShowPartiesRequest = exports.removeProjectCoverFailure = exports.removeProjectCoverSuccess = exports.removeProjectCoverRequest = exports.uploadProjectCoverFailure = exports.uploadProjectCoverSuccess = exports.uploadProjectCoverRequest = exports.addShortcutsFailed = exports.addShortcutsSuccess = exports.addShortcutsRequest = exports.fetchProjectGroupsFailed = exports.fetchProjectGroupsSuccess = exports.fetchProjectGroupsRequest = exports.editProjectImageFailed = exports.editProjectImageSuccess = exports.editProjectImageRequest = exports.fetchProjectImageFailed = exports.fetchProjectImageSuccess = exports.fetchProjectImageRequest = exports.deleteShortcutFailed = exports.deleteShortcutSuccess = exports.deleteShortcutRequest = exports.fetchShortcutsFailure = exports.fetchShortcutsSuccess = exports.fetchShortcutsRequest = exports.fetchRootFailure = exports.fetchRootSuccess = exports.fetchRootRequest = exports.fetchProjectByIdSuccess = exports.fetchProjectByIdFailure = exports.fetchProjectByIdRequest = exports.clear = exports.UsergroupInvite = exports.UsergroupList = exports.FolderTreeActions = void 0;
const ActionTypes = require("../../actionTypes/project/home");
const _FolderTreeActions = require("../../modules/files/tree/actions");
const _usergroupInvite = require("../../modules/usergroup/invite/actions");
const _usergroupList = require("../../modules/usergroup/list/actions");
exports.FolderTreeActions = _FolderTreeActions.default('project/home');
exports.UsergroupList = _usergroupList.default('project/home');
exports.UsergroupInvite = _usergroupInvite.default('project/home');
const clear = () => ({
    type: ActionTypes.CLEAR
});
exports.clear = clear;
const fetchProjectByIdRequest = (projectId, updateStatus = true) => ({
    type: ActionTypes.FETCH_PROJECT_BY_ID_REQUEST,
    payload: {
        projectId,
        updateStatus
    }
});
exports.fetchProjectByIdRequest = fetchProjectByIdRequest;
const fetchProjectByIdFailure = (error, updateStatus = true) => ({
    type: ActionTypes.FETCH_PROJECT_BY_ID_FAILURE,
    payload: error,
    updateStatus
});
exports.fetchProjectByIdFailure = fetchProjectByIdFailure;
const fetchProjectByIdSuccess = (project, updateStatus = true) => ({
    type: ActionTypes.FETCH_PROJECT_BY_ID_SUCCESS,
    payload: {
        project,
        updateStatus
    }
});
exports.fetchProjectByIdSuccess = fetchProjectByIdSuccess;
const fetchRootRequest = (project, feature = 'FILESTAB') => ({
    type: ActionTypes.FETCH_ROOT_REQUEST,
    payload: {
        project,
        feature
    }
});
exports.fetchRootRequest = fetchRootRequest;
const fetchRootSuccess = (node) => ({
    type: ActionTypes.FETCH_ROOT_SUCCESS,
    data: {
        node
    }
});
exports.fetchRootSuccess = fetchRootSuccess;
const fetchRootFailure = (error) => ({
    type: ActionTypes.FETCH_ROOT_FAILURE,
    payload: {
        error
    }
});
exports.fetchRootFailure = fetchRootFailure;
// #region SHORTCUT ACTIONS
const fetchShortcutsRequest = (projectId) => ({
    type: ActionTypes.FETCH_PROJECT_SHORTCUTS_REQUEST,
    payload: {
        projectId
    }
});
exports.fetchShortcutsRequest = fetchShortcutsRequest;
const fetchShortcutsSuccess = (files) => ({
    type: ActionTypes.FETCH_PROJECT_SHORTCUTS_SUCCCESS,
    data: {
        files
    }
});
exports.fetchShortcutsSuccess = fetchShortcutsSuccess;
const fetchShortcutsFailure = (error) => ({
    type: ActionTypes.FETCH_PROJECT_SHORTCUTS_FAILURE,
    payload: {
        error
    }
});
exports.fetchShortcutsFailure = fetchShortcutsFailure;
// Deleting related actions
const deleteShortcutRequest = (projectId, folderId) => ({
    type: ActionTypes.DELETE_SHORTCUT_REQUEST,
    payload: {
        projectId,
        folderId
    }
});
exports.deleteShortcutRequest = deleteShortcutRequest;
const deleteShortcutSuccess = (folderId) => ({
    type: ActionTypes.DELETE_SHORTCUT_SUCCESS,
    payload: {
        folderId
    }
});
exports.deleteShortcutSuccess = deleteShortcutSuccess;
const deleteShortcutFailed = (error) => ({
    type: ActionTypes.DELETE_SHORTCUT_FAILED,
    payload: {
        error
    }
});
exports.deleteShortcutFailed = deleteShortcutFailed;
//#endregion
//#region PROJECT IMAGE ACTIONS
// Fetching related action types
const fetchProjectImageRequest = () => ({
    type: ActionTypes.FETCH_PROJECT_IMAGE_REQUEST
});
exports.fetchProjectImageRequest = fetchProjectImageRequest;
const fetchProjectImageSuccess = (list) => ({
    type: ActionTypes.FETCH_PROJECT_IMAGE_SUCCESS,
    payload: {
        list
    }
});
exports.fetchProjectImageSuccess = fetchProjectImageSuccess;
const fetchProjectImageFailed = (error) => ({
    type: ActionTypes.FETCH_PROJECT_IMAGE_FAILED,
    payload: {
        error
    }
});
exports.fetchProjectImageFailed = fetchProjectImageFailed;
// Delete related actions
const editProjectImageRequest = () => ({
    type: ActionTypes.EDIT_PROJECT_IMAGE_REQUEST
});
exports.editProjectImageRequest = editProjectImageRequest;
const editProjectImageSuccess = (list, status) => ({
    type: ActionTypes.EDIT_PROJECT_IMAGE_SUCCESS,
    payload: {
        list,
        status
    }
});
exports.editProjectImageSuccess = editProjectImageSuccess;
const editProjectImageFailed = (error) => ({
    type: ActionTypes.EDIT_PROJECT_IMAGE_FAILED,
    payload: {
        error
    }
});
exports.editProjectImageFailed = editProjectImageFailed;
//#endregion
//#region PROJECT GROUP ACTIONS
// Fetching related action types
const fetchProjectGroupsRequest = (projectId) => ({
    type: ActionTypes.FETCH_PROJECT_GROUPS_REQUEST,
    payload: {
        projectId
    }
});
exports.fetchProjectGroupsRequest = fetchProjectGroupsRequest;
const fetchProjectGroupsSuccess = (list) => ({
    type: ActionTypes.FETCH_PROJECT_GROUPS_SUCCESS,
    payload: {
        list
    }
});
exports.fetchProjectGroupsSuccess = fetchProjectGroupsSuccess;
const fetchProjectGroupsFailed = (error) => ({
    type: ActionTypes.FETCH_PROJECT_GROUPS_FAILED,
    payload: {
        error
    }
});
exports.fetchProjectGroupsFailed = fetchProjectGroupsFailed;
const addShortcutsRequest = (folders, projectId) => ({
    type: ActionTypes.ADD_SHORTCUTS_REQUEST,
    payload: {
        folders,
        projectId
    }
});
exports.addShortcutsRequest = addShortcutsRequest;
const addShortcutsSuccess = (list) => ({
    type: ActionTypes.ADD_SHORTCUTS_SUCCESS,
    payload: {
        list
    }
});
exports.addShortcutsSuccess = addShortcutsSuccess;
const addShortcutsFailed = (error) => ({
    type: ActionTypes.ADD_SHORTCUTS_FAILED,
    payload: {
        error
    }
});
exports.addShortcutsFailed = addShortcutsFailed;
//#region COVER IMAGE
const uploadProjectCoverRequest = (projectId, file) => ({
    type: ActionTypes.UPLOAD_PROJECT_COVER_REQUEST,
    projectId,
    file
});
exports.uploadProjectCoverRequest = uploadProjectCoverRequest;
const uploadProjectCoverSuccess = (cover) => ({
    type: ActionTypes.UPLOAD_PROJECT_COVER_SUCCESS,
    cover
});
exports.uploadProjectCoverSuccess = uploadProjectCoverSuccess;
const uploadProjectCoverFailure = (error) => ({
    type: ActionTypes.UPLOAD_PROJECT_COVER_FAILURE,
    payload: error
});
exports.uploadProjectCoverFailure = uploadProjectCoverFailure;
const removeProjectCoverRequest = (projectId) => ({
    type: ActionTypes.REMOVE_PROJECT_COVER_REQUEST,
    projectId
});
exports.removeProjectCoverRequest = removeProjectCoverRequest;
const removeProjectCoverSuccess = () => ({
    type: ActionTypes.REMOVE_PROJECT_COVER_SUCCESS
});
exports.removeProjectCoverSuccess = removeProjectCoverSuccess;
const removeProjectCoverFailure = (error) => ({
    type: ActionTypes.REMOVE_PROJECT_COVER_FAILURE,
    payload: error
});
exports.removeProjectCoverFailure = removeProjectCoverFailure;
//#endregion
const toggleShowPartiesRequest = (projectId, showPartiesTab) => ({
    type: ActionTypes.TOGGLE_SHOW_PARTIES_REQUEST,
    payload: {
        projectId,
        showPartiesTab
    }
});
exports.toggleShowPartiesRequest = toggleShowPartiesRequest;
const toggleShowPartiesSuccess = (projectId, showPartiesTab) => ({
    type: ActionTypes.TOGGLE_SHOW_PARTIES_SUCCESS,
    payload: {
        projectId,
        showPartiesTab
    }
});
exports.toggleShowPartiesSuccess = toggleShowPartiesSuccess;
function toggleShowPartiesFailure(error) {
    return {
        type: ActionTypes.TOGGLE_SHOW_PARTIES_FAILURE,
        payload: error
    };
}
exports.toggleShowPartiesFailure = toggleShowPartiesFailure;
//# sourceMappingURL=home.js.map